var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIconTableColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42953",
    "data-name": "Group 42953",
    transform: "translate(-416 -325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42607",
    "data-name": "Group 42607",
    transform: "translate(416 325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    width: 30,
    height: 30,
    rx: 4,
    fill: "#f45e29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Horizontal_bar_chart",
    "data-name": "Horizontal bar chart",
    transform: "translate(418 330)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 22.105,
    height: 22.105,
    transform: "translate(2 -1)",
    fill: "#6a6a6a",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42869",
    "data-name": "Group 42869",
    transform: "translate(-305.863 301.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42897",
    "data-name": "Group 42897",
    transform: "translate(727.947 30.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10080",
    "data-name": "Rectangle 10080",
    d: "M1.5,0H16.417a1.5,1.5,0,0,1,1.5,1.5V3a0,0,0,0,1,0,0H0A0,0,0,0,1,0,3V1.5A1.5,1.5,0,0,1,1.5,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42896",
    "data-name": "Group 42896",
    transform: "translate(0 1.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10090",
    "data-name": "Rectangle 10090",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.917,
    height: 14.87,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 16.417,
    height: 13.37,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y2: 12.87,
    transform: "translate(5.972 0.982)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 15.917,
    transform: "translate(1 5.453)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 15.917,
    transform: "translate(1 9.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y2: 12.87,
    transform: "translate(11.944 0.982)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIconTableColored);
export default __webpack_public_path__ + "static/media/chart-icon-table-colored.4d9d59e8.svg";
export { ForwardRef as ReactComponent };